
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class TaskEditorHome extends Vue {
  @Prop({ type: Boolean }) isDrawerOpen?: boolean
}
